import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import DocumentCircleIcon from '../../../../assets/document-circle-icon.svg';

const NewsletterArticleMentionNotification = ({ notification }) => {
  const meta = getMeta(notification);

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={DocumentCircleIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> mentioned you on their</span>{' '}
          <span className="font-extrabold text-growth-green">article</span>
        </p>
        {meta.articleTitle && (
          <p className="text-sm text-growth-green-900 font-extrabold mb-2 mt-1">
            {`"${meta.articleTitle}"`}
          </p>
        )}
      </div>
    </div>
  );
};

export default NewsletterArticleMentionNotification;
